import * as amplitude from '@amplitude/analytics-browser';
import { isAmplitudeInitialized } from './initialization';

// Declare window.amplitude type

/**
 * Fire an analytics event using the modern Amplitude SDK
 * @param type - The type of event to fire
 * @param properties - The properties to fire the event with
 */
export var trackAmplitudeEvent = function trackAmplitudeEvent(_ref) {
  var type = _ref.type,
    properties = _ref.properties;
  // Check if the modern Amplitude SDK is initialized
  if (isAmplitudeInitialized()) {
    try {
      amplitude.track(type, properties);
    } catch (error) {
      console.warn('Failed to track Amplitude event:', error);
    }
    return;
  }

  // Fallback to legacy window.amplitude if modern SDK is not available
  var MAX_RETRIES = 100; // 100 retries * 100ms = 10 seconds
  var RETRY_INTERVAL = 100; // 100 milliseconds

  var retryCount = 0;
  var tryTrackEvent = function tryTrackEvent() {
    if (window.amplitude) {
      window.amplitude.track(type, properties);
    } else if (retryCount < MAX_RETRIES) {
      retryCount++;
      setTimeout(tryTrackEvent, RETRY_INTERVAL);
    } else {
      console.warn('Amplitude SDK not available after retries, event not tracked:', type);
    }
  };
  tryTrackEvent();
};